import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AllocateProductionLotToOrderLineMutationVariables = Types.Exact<{
  input: Types.AllocateProductionLotToOrderLineInput;
}>;


export type AllocateProductionLotToOrderLineMutation = { __typename?: 'Mutation', allocateProductionLotToOrderLine: { __typename?: 'OrderProductionLotAllocationPayload', orderProductionLotAllocation?: { __typename?: 'OrderProductionLotAllocationDocument', id: string, tenantId: string, orderId: string, orderLineId: string, productionLotId: string, allocatedQty: number, peggedQty: number, orderedQty: number, lotQty: number, readyWeek: Types.TDateISO, status: Types.OrderProductionLotAllocationStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AdjustProductionLotAllocationMutationVariables = Types.Exact<{
  input: Types.AdjustProductionLotAllocationInput;
}>;


export type AdjustProductionLotAllocationMutation = { __typename?: 'Mutation', adjustProductionLotAllocation: { __typename?: 'OrderProductionLotAllocationPayload', orderProductionLotAllocation?: { __typename?: 'OrderProductionLotAllocationDocument', id: string, tenantId: string, orderId: string, orderLineId: string, productionLotId: string, allocatedQty: number, peggedQty: number, orderedQty: number, lotQty: number, readyWeek: Types.TDateISO, status: Types.OrderProductionLotAllocationStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelProductionLotAllocationMutationVariables = Types.Exact<{
  input: Types.CancelProductionLotAllocationInput;
}>;


export type CancelProductionLotAllocationMutation = { __typename?: 'Mutation', cancelProductionLotAllocation: { __typename?: 'OrderProductionLotAllocationPayload', orderProductionLotAllocation?: { __typename?: 'OrderProductionLotAllocationDocument', id: string, tenantId: string, orderId: string, orderLineId: string, productionLotId: string, allocatedQty: number, peggedQty: number, orderedQty: number, lotQty: number, readyWeek: Types.TDateISO, status: Types.OrderProductionLotAllocationStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AllocateProductionLotToOrderLineDocument = new TypedDocumentString(`
    mutation AllocateProductionLotToOrderLine($input: AllocateProductionLotToOrderLineInput!) {
  allocateProductionLotToOrderLine(input: $input) {
    orderProductionLotAllocation {
      ...OrderProductionLotAllocationFragment
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderProductionLotAllocationFragment on OrderProductionLotAllocationDocument {
  id
  tenantId
  orderId
  orderLineId
  productionLotId
  allocatedQty
  peggedQty
  orderedQty
  lotQty
  readyWeek
  status
  createdAt
  updatedAt
}`);
export const AdjustProductionLotAllocationDocument = new TypedDocumentString(`
    mutation AdjustProductionLotAllocation($input: AdjustProductionLotAllocationInput!) {
  adjustProductionLotAllocation(input: $input) {
    orderProductionLotAllocation {
      ...OrderProductionLotAllocationFragment
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderProductionLotAllocationFragment on OrderProductionLotAllocationDocument {
  id
  tenantId
  orderId
  orderLineId
  productionLotId
  allocatedQty
  peggedQty
  orderedQty
  lotQty
  readyWeek
  status
  createdAt
  updatedAt
}`);
export const CancelProductionLotAllocationDocument = new TypedDocumentString(`
    mutation CancelProductionLotAllocation($input: CancelProductionLotAllocationInput!) {
  cancelProductionLotAllocation(input: $input) {
    orderProductionLotAllocation {
      ...OrderProductionLotAllocationFragment
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderProductionLotAllocationFragment on OrderProductionLotAllocationDocument {
  id
  tenantId
  orderId
  orderLineId
  productionLotId
  allocatedQty
  peggedQty
  orderedQty
  lotQty
  readyWeek
  status
  createdAt
  updatedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AllocateProductionLotToOrderLine: build.mutation<AllocateProductionLotToOrderLineMutation, AllocateProductionLotToOrderLineMutationVariables>({
      query: (variables) => ({ document: AllocateProductionLotToOrderLineDocument, variables })
    }),
    AdjustProductionLotAllocation: build.mutation<AdjustProductionLotAllocationMutation, AdjustProductionLotAllocationMutationVariables>({
      query: (variables) => ({ document: AdjustProductionLotAllocationDocument, variables })
    }),
    CancelProductionLotAllocation: build.mutation<CancelProductionLotAllocationMutation, CancelProductionLotAllocationMutationVariables>({
      query: (variables) => ({ document: CancelProductionLotAllocationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAllocateProductionLotToOrderLineMutation, useAdjustProductionLotAllocationMutation, useCancelProductionLotAllocationMutation } = injectedRtkApi;
